var _rect, _mask, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 300,
    viewBox: "0 0 250 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 250,
    height: 300,
    fill: "white"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_135_637",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.0278 242.841C30.2818 201.375 27.9785 134.023 27.7939 123.496C28.1954 97.5862 36.0791 79.2523 47.035 66.2792C73.5487 34.8838 118.056 34.8839 118.056 34.8839H131.945C131.945 34.8839 176.451 34.8838 202.965 66.2792C213.921 79.2523 221.805 97.5862 222.206 123.496C222.022 134.023 219.718 201.375 190.972 242.841C177.715 261.964 172.724 261.628 145.833 261.628C145.833 261.628 232.075 152.705 173.611 115.116L139.843 117.54C129.96 118.249 120.04 118.249 110.157 117.54L76.3889 115.116C17.9254 152.705 104.167 261.628 104.167 261.628C77.2765 261.628 72.2847 261.964 59.0278 242.841Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.0278 242.841C30.2818 201.375 27.9785 134.023 27.7939 123.496C28.1954 97.5862 36.0791 79.2523 47.035 66.2792C73.5487 34.8838 118.056 34.8839 118.056 34.8839H131.945C131.945 34.8839 176.451 34.8838 202.965 66.2792C213.921 79.2523 221.805 97.5862 222.206 123.496C222.022 134.023 219.718 201.375 190.972 242.841C177.715 261.964 172.724 261.628 145.833 261.628C145.833 261.628 232.075 152.705 173.611 115.116L139.843 117.54C129.96 118.249 120.04 118.249 110.157 117.54L76.3889 115.116C17.9254 152.705 104.167 261.628 104.167 261.628C77.2765 261.628 72.2847 261.964 59.0278 242.841Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7939 123.496L28.044 123.5L28.0439 123.492L27.7939 123.496ZM27.5278 125.582C27.5278 125.72 27.6398 125.832 27.7778 125.832C27.9159 125.832 28.0278 125.72 28.0278 125.582H27.5278ZM222.206 123.496L221.956 123.492L221.956 123.5L222.206 123.496ZM221.972 125.582C221.972 125.72 222.084 125.832 222.222 125.832C222.36 125.832 222.472 125.72 222.472 125.582H221.972ZM27.7778 122.093C27.5278 122.093 27.5278 122.093 27.5278 122.093C27.5278 122.093 27.5278 122.093 27.5278 122.093C27.5278 122.093 27.5278 122.093 27.5278 122.093C27.5278 122.093 27.5278 122.093 27.5278 122.094C27.5278 122.094 27.5278 122.094 27.5278 122.095C27.5278 122.096 27.5278 122.097 27.5278 122.099C27.5278 122.103 27.5278 122.109 27.5279 122.116C27.5279 122.132 27.528 122.154 27.5281 122.184C27.5283 122.245 27.5288 122.334 27.5299 122.453C27.5319 122.69 27.5359 123.041 27.5439 123.5L28.0439 123.492C28.0358 123.034 28.0318 122.684 28.0298 122.449C28.0288 122.331 28.0283 122.242 28.0281 122.182C28.028 122.153 28.0279 122.13 28.0279 122.115C28.0278 122.108 28.0278 122.102 28.0278 122.099C28.0278 122.097 28.0278 122.095 28.0278 122.094C28.0278 122.094 28.0278 122.094 28.0278 122.093C28.0278 122.093 28.0278 122.093 28.0278 122.093C28.0278 122.093 28.0278 122.093 28.0278 122.093C28.0278 122.093 28.0278 122.093 28.0278 122.093C28.0278 122.093 28.0278 122.093 27.7778 122.093ZM27.5439 123.492C27.5332 124.183 27.5278 124.88 27.5278 125.582H28.0278C28.0278 124.882 28.0332 124.188 28.0439 123.5L27.5439 123.492ZM222.222 122.093C221.972 122.093 221.972 122.093 221.972 122.093C221.972 122.093 221.972 122.093 221.972 122.093C221.972 122.093 221.972 122.093 221.972 122.093C221.972 122.093 221.972 122.093 221.972 122.093C221.972 122.094 221.972 122.094 221.972 122.094C221.972 122.095 221.972 122.097 221.972 122.099C221.972 122.102 221.972 122.108 221.972 122.115C221.972 122.13 221.972 122.153 221.972 122.182C221.972 122.242 221.971 122.331 221.97 122.449C221.968 122.684 221.964 123.034 221.956 123.492L222.456 123.5C222.464 123.041 222.468 122.69 222.47 122.453C222.471 122.334 222.472 122.245 222.472 122.184C222.472 122.154 222.472 122.132 222.472 122.116C222.472 122.109 222.472 122.103 222.472 122.099C222.472 122.097 222.472 122.096 222.472 122.095C222.472 122.094 222.472 122.094 222.472 122.094C222.472 122.093 222.472 122.093 222.472 122.093C222.472 122.093 222.472 122.093 222.472 122.093C222.472 122.093 222.472 122.093 222.472 122.093C222.472 122.093 222.472 122.093 222.222 122.093ZM221.956 123.5C221.967 124.188 221.972 124.882 221.972 125.582H222.472C222.472 124.88 222.467 124.183 222.456 123.492L221.956 123.5ZM114.583 35.1339H118.056V34.6339H114.583V35.1339ZM131.945 35.1339H135.417V34.6339H131.945V35.1339ZM27.7939 123.496L27.294 123.488L27.2938 123.496L27.294 123.505L27.7939 123.496ZM59.0278 242.841L58.6169 243.126L59.0278 242.841ZM104.167 261.628V262.128H105.2L104.559 261.318L104.167 261.628ZM118.056 34.8839V35.3839V34.8839ZM47.035 66.2792L46.653 65.9566L47.035 66.2792ZM222.206 123.496L222.706 123.505L222.706 123.496L222.706 123.488L222.206 123.496ZM190.972 242.841L191.383 243.126L190.972 242.841ZM145.833 261.628L145.441 261.318L144.8 262.128H145.833V261.628ZM131.945 34.8839V35.3839V34.8839ZM202.965 66.2792L203.347 65.9566L202.965 66.2792ZM173.611 115.116L173.882 114.696L173.742 114.606L173.575 114.618L173.611 115.116ZM76.3889 115.116L76.4247 114.618L76.2586 114.606L76.1185 114.696L76.3889 115.116ZM139.843 117.54L139.879 118.038L139.843 117.54ZM110.157 117.54L110.121 118.038L110.157 117.54ZM27.294 123.505C27.3865 128.783 28.0096 148.282 32.2082 171.655C36.405 195.018 44.1833 222.305 58.6169 243.126L59.4388 242.556C45.1263 221.91 37.38 194.789 33.1924 171.478C29.0067 148.177 28.3858 128.736 28.2938 123.487L27.294 123.505ZM58.6169 243.126C65.253 252.698 69.8901 257.511 76.3121 259.875C79.511 261.052 83.1254 261.612 87.6038 261.881C92.0791 262.149 97.4516 262.128 104.167 262.128V261.128C97.4367 261.128 92.1014 261.149 87.6636 260.883C83.2289 260.617 79.7249 260.065 76.6575 258.936C70.5468 256.687 66.0596 252.107 59.4388 242.556L58.6169 243.126ZM118.056 34.8839C118.056 34.3839 118.055 34.3839 118.055 34.3839C118.054 34.3839 118.054 34.3839 118.053 34.3839C118.051 34.3839 118.049 34.3839 118.046 34.3839C118.04 34.3839 118.032 34.3839 118.02 34.384C117.998 34.3841 117.965 34.3844 117.922 34.3848C117.835 34.3858 117.706 34.3878 117.538 34.3916C117.201 34.3994 116.706 34.4149 116.067 34.4458C114.79 34.5075 112.938 34.6308 110.634 34.8772C106.027 35.37 99.6079 36.3552 92.3568 38.3258C77.8606 42.2652 59.999 50.1534 46.653 65.9566L47.417 66.6018C60.5848 51.0096 78.2335 43.2001 92.6191 39.2908C99.8089 37.3369 106.174 36.3599 110.74 35.8716C113.023 35.6274 114.856 35.5055 116.116 35.4446C116.746 35.4141 117.232 35.399 117.561 35.3914C117.725 35.3876 117.85 35.3857 117.933 35.3848C117.974 35.3843 118.005 35.3841 118.026 35.384C118.036 35.3839 118.044 35.3839 118.049 35.3839C118.051 35.3839 118.053 35.3839 118.054 35.3839C118.055 35.3839 118.055 35.3839 118.055 35.3839C118.056 35.3839 118.056 35.3839 118.056 34.8839ZM46.653 65.9566C35.6164 79.0252 27.6971 97.4729 27.294 123.488L28.2938 123.504C28.6937 97.6995 36.5417 79.4795 47.417 66.6018L46.653 65.9566ZM221.706 123.487C221.614 128.736 220.993 148.177 216.808 171.478C212.62 194.789 204.874 221.91 190.561 242.556L191.383 243.126C205.817 222.305 213.595 195.018 217.792 171.655C221.991 148.282 222.614 128.783 222.706 123.505L221.706 123.487ZM190.561 242.556C183.941 252.107 179.453 256.687 173.343 258.936C170.275 260.065 166.771 260.617 162.336 260.883C157.899 261.149 152.563 261.128 145.833 261.128V262.128C152.549 262.128 157.921 262.149 162.396 261.881C166.875 261.612 170.489 261.052 173.688 259.875C180.11 257.511 184.747 252.698 191.383 243.126L190.561 242.556ZM131.945 34.8839C131.945 35.3839 131.945 35.3839 131.945 35.3839C131.945 35.3839 131.945 35.3839 131.946 35.3839C131.947 35.3839 131.949 35.3839 131.951 35.3839C131.956 35.3839 131.964 35.3839 131.974 35.384C131.995 35.3841 132.026 35.3843 132.067 35.3848C132.15 35.3857 132.275 35.3876 132.439 35.3914C132.768 35.399 133.255 35.4141 133.885 35.4446C135.145 35.5055 136.977 35.6274 139.26 35.8716C143.826 36.3599 150.191 37.3369 157.381 39.2908C171.767 43.2001 189.415 51.0096 202.583 66.6018L203.347 65.9566C190.001 50.1534 172.14 42.2652 157.643 38.3258C150.392 36.3552 143.973 35.37 139.366 34.8772C137.062 34.6308 135.21 34.5075 133.933 34.4458C133.294 34.4149 132.799 34.3994 132.462 34.3916C132.294 34.3878 132.166 34.3858 132.079 34.3848C132.035 34.3844 132.002 34.3841 131.98 34.384C131.968 34.3839 131.96 34.3839 131.954 34.3839C131.951 34.3839 131.949 34.3839 131.947 34.3839C131.946 34.3839 131.946 34.3839 131.945 34.3839C131.945 34.3839 131.945 34.3839 131.945 34.8839ZM202.583 66.6018C213.458 79.4795 221.306 97.6995 221.706 123.504L222.706 123.488C222.303 97.4729 214.384 79.0252 203.347 65.9566L202.583 66.6018ZM118.056 35.3839H131.945V34.3839H118.056V35.3839ZM145.833 261.628C146.225 261.938 146.226 261.938 146.227 261.937C146.227 261.936 146.228 261.935 146.23 261.933C146.232 261.93 146.236 261.925 146.242 261.918C146.252 261.904 146.268 261.884 146.289 261.858C146.331 261.805 146.392 261.726 146.473 261.622C146.636 261.413 146.875 261.104 147.185 260.699C147.804 259.89 148.704 258.699 149.828 257.171C152.076 254.113 155.221 249.705 158.812 244.298C165.992 233.486 174.961 218.671 182.103 202.672C189.241 186.681 194.572 169.465 194.435 153.862C194.298 138.233 188.668 124.203 173.882 114.696L173.341 115.537C187.786 124.825 193.3 138.505 193.435 153.871C193.571 169.264 188.304 186.326 181.19 202.264C174.079 218.195 165.141 232.959 157.979 243.745C154.398 249.137 151.262 253.532 149.022 256.578C147.902 258.101 147.006 259.287 146.391 260.092C146.083 260.494 145.845 260.801 145.685 261.007C145.604 261.11 145.543 261.188 145.502 261.24C145.482 261.266 145.467 261.286 145.456 261.299C145.451 261.305 145.448 261.31 145.445 261.313C145.444 261.315 145.443 261.316 145.442 261.317C145.442 261.317 145.441 261.318 145.833 261.628ZM104.167 261.628C104.559 261.318 104.558 261.317 104.558 261.317C104.557 261.316 104.556 261.315 104.555 261.313C104.553 261.31 104.549 261.305 104.544 261.299C104.533 261.286 104.518 261.266 104.498 261.24C104.457 261.188 104.396 261.11 104.316 261.007C104.155 260.801 103.917 260.494 103.61 260.092C102.994 259.287 102.098 258.101 100.978 256.578C98.738 253.532 95.6023 249.137 92.0215 243.745C84.8587 232.959 75.9215 218.195 68.8106 202.264C61.6961 186.326 56.4295 169.264 56.5649 153.871C56.7 138.505 62.2137 124.825 76.6594 115.537L76.1185 114.696C61.3324 124.203 55.7024 138.233 55.5649 153.862C55.4277 169.465 60.7595 186.681 67.8974 202.672C75.0389 218.671 84.0081 233.486 91.1885 244.298C94.7794 249.705 97.9245 254.113 100.172 257.171C101.296 258.699 102.196 259.89 102.815 260.699C103.125 261.104 103.364 261.413 103.527 261.622C103.608 261.726 103.67 261.805 103.711 261.858C103.732 261.884 103.748 261.904 103.758 261.918C103.764 261.925 103.768 261.93 103.77 261.933C103.772 261.935 103.773 261.936 103.774 261.937C103.774 261.938 103.775 261.938 104.167 261.628ZM173.575 114.618L139.807 117.041L139.879 118.038L173.647 115.615L173.575 114.618ZM110.193 117.041L76.4247 114.618L76.3532 115.615L110.121 118.038L110.193 117.041ZM139.807 117.041C129.948 117.748 120.052 117.748 110.193 117.041L110.121 118.038C120.028 118.749 129.972 118.749 139.879 118.038L139.807 117.041Z",
    fill: "black",
    mask: "url(#path-2-inside-1_135_637)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1021 163.337L59.7159 157.967C57.1906 152.284 58.2843 145.644 62.4988 141.071C65.4505 137.869 69.6073 136.047 73.9626 136.047H81.5482C83.5058 136.047 85.4592 136.226 87.3839 136.583L98.6974 138.682C101.747 139.247 104.69 140.281 107.423 141.745L111.024 143.674C114.46 145.516 117.202 148.427 118.834 151.968C122.417 159.743 119.999 168.966 113.063 173.984L112.543 174.359C109.355 176.666 105.521 177.907 101.586 177.907H84.52C74.8248 177.907 66.0391 172.197 62.1021 163.337Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M187.898 163.337L190.284 157.967C192.809 152.284 191.716 145.644 187.501 141.071C184.55 137.869 180.393 136.047 176.037 136.047H168.452C166.494 136.047 164.541 136.226 162.616 136.583L151.303 138.682C148.253 139.247 145.31 140.281 142.577 141.745L138.976 143.674C135.54 145.516 132.798 148.427 131.166 151.968C127.583 159.743 130.001 168.966 136.937 173.984L137.457 174.359C140.645 176.666 144.479 177.907 148.414 177.907H165.48C175.175 177.907 183.961 172.197 187.898 163.337Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M121.528 160.465H128.472",
    stroke: "black",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2336 143.895C78.2501 144.028 78.4509 144.53 78.1251 144.55C77.8409 144.566 77.4033 144.696 77.6911 144.986",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5825 147.166C77.7527 147.187 77.946 147.569 78.0165 147.711",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5825 150.218C77.9494 150.218 77.908 150.468 77.908 150.763",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M77.691 153.597C77.8578 153.765 78.0413 154.046 78.2336 154.143",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M77.908 156.214C77.908 156.654 77.7927 156.984 77.474 157.304",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1251 158.612C78.1251 158.922 78.0971 159.226 77.7996 159.375",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M77.691 162.318H77.9081",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0165 164.281V164.499",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5825 166.243V166.461",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M84.093 143.023C84.1095 143.156 84.3102 143.658 83.9845 143.677C83.7003 143.694 83.2627 143.824 83.5504 144.113",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M83.4419 146.294C83.612 146.315 83.8054 146.697 83.8759 146.839",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M83.4419 149.346C83.8088 149.346 83.7674 149.596 83.7674 149.891",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5504 152.725C83.7172 152.893 83.9007 153.174 84.0929 153.27",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7674 155.342C83.7674 155.782 83.6521 156.112 83.3334 156.432",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9845 157.74C83.9845 158.05 83.9564 158.354 83.6589 158.503",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5504 161.446H83.7674",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8759 163.409V163.627",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M83.4419 165.371V165.589",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0374 143.023C91.0539 143.156 91.2547 143.658 90.9289 143.677C90.6448 143.694 90.2071 143.824 90.4949 144.113",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3864 146.294C90.5565 146.315 90.7498 146.697 90.8204 146.839",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3864 149.346C90.7533 149.346 90.7119 149.596 90.7119 149.891",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4949 152.725C90.6617 152.893 90.8451 153.174 91.0374 153.27",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M90.7119 155.342C90.7119 155.782 90.5966 156.112 90.2778 156.432",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M90.9289 157.74C90.9289 158.05 90.9009 158.354 90.6034 158.503",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4949 161.446H90.7119",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8203 163.409V163.627",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3864 165.371V165.589",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M97.9819 150C97.9984 150.133 98.1992 150.635 97.8734 150.654C97.5892 150.671 97.1516 150.801 97.4394 151.09",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3308 153.27C97.5009 153.292 97.6943 153.674 97.7648 153.816",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3308 156.323C97.6977 156.323 97.6563 156.573 97.6563 156.868",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M97.4393 159.702C97.6061 159.87 97.7896 160.151 97.9819 160.247",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6563 162.318C97.6563 162.758 97.541 163.088 97.2223 163.409",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8734 164.717C97.8734 165.027 97.8454 165.33 97.5479 165.48",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M97.4393 168.423H97.6563",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7648 170.385V170.603",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3308 172.348V172.566",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M104.926 150C104.943 150.133 105.144 150.635 104.818 150.654C104.534 150.671 104.096 150.801 104.384 151.09",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M104.275 153.27C104.445 153.292 104.639 153.674 104.709 153.816",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M104.275 156.323C104.642 156.323 104.601 156.573 104.601 156.868",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M104.384 159.702C104.551 159.87 104.734 160.151 104.926 160.247",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M104.601 162.318C104.601 162.758 104.485 163.088 104.167 163.409",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M104.818 164.717C104.818 165.027 104.79 165.33 104.492 165.48",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M104.384 168.423H104.601",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M104.709 170.385V170.603",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M104.275 172.348V172.566",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M111.871 150C111.887 150.133 112.088 150.635 111.762 150.654C111.478 150.671 111.04 150.801 111.328 151.09",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M111.22 153.27C111.39 153.292 111.583 153.674 111.654 153.816",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M111.22 156.323C111.587 156.323 111.545 156.573 111.545 156.868",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M111.328 159.702C111.495 159.87 111.679 160.151 111.871 160.247",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M111.545 162.318C111.545 162.758 111.43 163.088 111.111 163.409",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M111.762 164.717C111.762 165.027 111.734 165.33 111.437 165.48",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M111.328 168.423H111.545",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M111.654 170.385V170.603",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M111.22 172.348V172.566",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M172.602 143.895C172.586 144.028 172.385 144.53 172.711 144.55C172.995 144.566 173.433 144.696 173.145 144.986",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M173.253 147.166C173.083 147.187 172.89 147.569 172.819 147.711",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M173.253 150.218C172.886 150.218 172.928 150.468 172.928 150.763",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M173.145 153.597C172.978 153.765 172.795 154.046 172.602 154.143",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M172.928 156.214C172.928 156.654 173.043 156.984 173.362 157.304",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M172.711 158.612C172.711 158.922 172.739 159.226 173.036 159.375",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M173.145 162.318H172.928",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M172.819 164.281V164.499",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M173.253 166.243V166.461",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M166.743 143.023C166.726 143.156 166.526 143.658 166.851 143.677C167.136 143.694 167.573 143.824 167.285 144.113",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M167.394 146.294C167.224 146.315 167.03 146.697 166.96 146.839",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M167.394 149.346C167.027 149.346 167.068 149.596 167.068 149.891",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M167.285 152.725C167.119 152.893 166.935 153.174 166.743 153.27",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M167.068 155.342C167.068 155.782 167.184 156.112 167.502 156.432",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M166.851 157.74C166.851 158.05 166.879 158.354 167.177 158.503",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M167.285 161.446H167.068",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M166.96 163.409V163.627",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M167.394 165.371V165.589",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M159.798 143.023C159.782 143.156 159.581 143.658 159.907 143.677C160.191 143.694 160.629 143.824 160.341 144.113",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M160.449 146.294C160.279 146.315 160.086 146.697 160.015 146.839",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M160.449 149.346C160.083 149.346 160.124 149.596 160.124 149.891",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M160.341 152.725C160.174 152.893 159.991 153.174 159.798 153.27",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M160.124 155.342C160.124 155.782 160.239 156.112 160.558 156.432",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M159.907 157.74C159.907 158.05 159.935 158.354 160.232 158.503",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M160.341 161.446H160.124",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M160.015 163.409V163.627",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M160.449 165.371V165.589",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M152.854 150C152.837 150.133 152.637 150.635 152.962 150.654C153.247 150.671 153.684 150.801 153.396 151.09",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M153.505 153.27C153.335 153.292 153.142 153.674 153.071 153.816",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M153.505 156.323C153.138 156.323 153.179 156.573 153.179 156.868",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M153.396 159.702C153.23 159.87 153.046 160.151 152.854 160.247",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M153.179 162.318C153.179 162.758 153.295 163.088 153.614 163.409",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M152.962 164.717C152.962 165.027 152.99 165.33 153.288 165.48",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M153.396 168.423H153.179",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M153.071 170.385V170.603",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M153.505 172.348V172.566",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M145.909 150C145.893 150.133 145.692 150.635 146.018 150.654C146.302 150.671 146.74 150.801 146.452 151.09",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M146.561 153.27C146.39 153.292 146.197 153.674 146.127 153.816",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M146.561 156.323C146.194 156.323 146.235 156.573 146.235 156.868",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M146.452 159.702C146.285 159.87 146.102 160.151 145.909 160.247",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M146.235 162.318C146.235 162.758 146.35 163.088 146.669 163.409",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M146.018 164.717C146.018 165.027 146.046 165.33 146.344 165.48",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M146.452 168.423H146.235",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M146.127 170.385V170.603",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M146.561 172.348V172.566",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M138.965 150C138.949 150.133 138.748 150.635 139.074 150.654C139.358 150.671 139.795 150.801 139.508 151.09",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M139.616 153.27C139.446 153.292 139.253 153.674 139.182 153.816",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M139.616 156.323C139.249 156.323 139.291 156.573 139.291 156.868",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M139.508 159.702C139.341 159.87 139.157 160.151 138.965 160.247",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M139.291 162.318C139.291 162.758 139.406 163.088 139.725 163.409",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M139.074 164.717C139.074 165.027 139.102 165.33 139.399 165.48",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M139.508 168.423H139.291",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M139.182 170.385V170.603",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M139.616 172.348V172.566",
    stroke: "#00FF41",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M150.373 221.695C150.373 225.513 138.351 232.758 125.063 233.68C111.143 231.836 99.7532 225.974 99.7532 222.156C99.7532 218.337 111.775 213.053 125.063 220.889C135.82 213.053 150.373 217.876 150.373 221.695Z",
    fill: "#CA0808"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M124.357 221.382C116.966 216.642 107.636 216.354 100.01 220.517C99.657 220.407 99.3046 220.294 98.9529 220.179C106.711 215.623 116.329 215.646 124.069 220.246L123.808 220.422L124.082 220.836L124.4 221.316L124.357 221.382ZM125.6 221.316L125.918 220.836L126.192 220.422L125.931 220.246C133.671 215.646 143.289 215.623 151.047 220.179C150.695 220.294 150.343 220.407 149.99 220.517C142.364 216.354 133.034 216.642 125.643 221.382L125.6 221.316ZM100.123 221.599C116.338 226.577 133.662 226.577 149.877 221.599C149.895 221.609 149.912 221.619 149.929 221.629C149.564 222.019 149.192 222.399 148.813 222.769C133.255 227.278 116.745 227.278 101.187 222.769C100.808 222.399 100.436 222.019 100.07 221.629C100.088 221.619 100.105 221.609 100.123 221.599ZM150.793 222.169C150.797 222.165 150.8 222.161 150.804 222.156C150.808 222.158 150.811 222.16 150.814 222.163C150.807 222.165 150.8 222.167 150.793 222.169ZM149.331 223.66C149.88 223.499 150.428 223.332 150.975 223.16C136.824 237.97 113.176 237.97 99.025 223.16C99.5717 223.332 100.12 223.499 100.669 223.66C114.239 236.713 135.761 236.713 149.331 223.66ZM99.2073 222.169C99.2002 222.167 99.1931 222.165 99.186 222.163C99.1892 222.161 99.1923 222.159 99.1955 222.156C99.1994 222.161 99.2033 222.165 99.2073 222.169Z",
    fill: "#CA0808",
    stroke: "black",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo-icon.5db03023aa3e2528fcde21a91c45f294.svg";
export { ForwardRef as ReactComponent };